import React from 'react';

interface IProps {
  bodyColor?: string;
}

export const BlockFolderIcon = ({ bodyColor = '#36D183' }: IProps) => (
  <svg width="56" height="56" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M47.5957 11.639H27.2107C26.7213 11.639 26.2434 11.4935 25.8412 11.2221L21.6839 8.41691C21.2816 8.14548 20.8037 8 20.3144 8H8.40415C7.07638 8 6 9.04784 6 10.3404V20H50V13.9793C49.9999 12.6868 48.9235 11.639 47.5957 11.639Z"
      fill={bodyColor}
    />
    <rect x="9" y="16" width="37" height="18" rx="2" fill="white" />
    <g filter="url(#filter0_f_11744_36280)">
      <rect x="7.42188" y="18" width="41" height="2" fill="black" fillOpacity="0.3" />
    </g>
    <path
      d="M47.6837 47H8.31629C6.79319 47 5.53336 45.8343 5.44141 44.34L4.00536 21.0018C3.90522 19.3741 5.22119 18 6.88024 18H49.1198C50.7788 18 52.0948 19.3741 51.9946 21.0018L50.5586 44.34C50.4666 45.8343 49.2069 47 47.6837 47Z"
      fill={bodyColor}
    />
    <path
      d="M35.2826 31.4284L33.4826 27.8134C33.1301 27.1009 32.1926 26.5234 31.3976 26.5234H24.6026C23.8076 26.5234 22.8701 27.1009 22.5176 27.8134L20.7176 31.4284C20.2826 32.2984 20.5226 33.5359 21.2351 34.1884L26.4326 38.9059C27.2951 39.6859 28.6976 39.6859 29.5601 38.9059L34.7576 34.1884C35.4776 33.5359 35.7176 32.2909 35.2826 31.4284ZM31.0001 30.9409H28.5626V34.8784C28.5626 35.1859 28.3076 35.4409 28.0001 35.4409C27.6926 35.4409 27.4376 35.1859 27.4376 34.8784V30.9409H25.0001C24.6926 30.9409 24.4376 30.6859 24.4376 30.3784C24.4376 30.0709 24.6926 29.8159 25.0001 29.8159H31.0001C31.3076 29.8159 31.5626 30.0709 31.5626 30.3784C31.5626 30.6859 31.3076 30.9409 31.0001 30.9409Z"
      fill="#F9FAFB"
    />
    <defs>
      <filter
        id="filter0_f_11744_36280"
        x="5.42188"
        y="16"
        width="45"
        height="6"
        filterUnits="userSpaceOnUse"
        // eslint-disable-next-line react/no-unknown-property
        color-interpolation-dilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur stdDeviation="1" result="effect1_foregroundBlur_11744_36280" />
      </filter>
    </defs>
  </svg>
);
